(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('CloudPBXController', CloudPBXController);

    /* Added UIFormAccess
    CloudPBXController.$inject = ['$state', 'CloudPBX', 'CloudPBXSearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function CloudPBXController($state, CloudPBX, CloudPBXSearch, ParseLinks, AlertService, paginationConstants, pagingParams) {
    */
    CloudPBXController.$inject = ['$state', 'CloudPBX', 'CloudPBXSearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams', 'UIFormAccess'];

    function CloudPBXController($state, CloudPBX, CloudPBXSearch, ParseLinks, AlertService, paginationConstants, pagingParams, UIFormAccess) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.UIFormAccess = UIFormAccess;

        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                CloudPBXSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                CloudPBX.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                /*
                if (vm.predicate !== 'id') {
                    result.push('id');
                */
                if (vm.predicate !== 'name') {
                    result.push('name');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.cloudPBXES = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            /*
            vm.predicate = 'id';
            */
            vm.predicate = 'name';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();
